/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/*!
 * Amplify 1.1.2
 *
 * Copyright 2011 - 2013 appendTo LLC. (http://appendto.com/team)
 * Dual licensed under the MIT or GPL licenses.
 * http://appendto.com/open-source-licenses
 *
 * http://amplifyjs.com
 */

const subscriptions: Record<
  string,
  { callback: Function; context: Function; priority?: number }[]
> = {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function publish(topic: string, ...args: any[]): boolean {
  if (typeof topic !== 'string') {
    throw new Error('You must provide a valid topic to publish.')
  }

  const topicSubscriptions = subscriptions[topic] || []

  let ret = true
  for (const subscription of topicSubscriptions) {
    const result = subscription.callback.apply(subscription.context, args)
    if (result === false) {
      break
    }
    ret = false
  }
  return !ret
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function subscribe(topic: string, context: any, callback?: any, priority?: any) {
  if (typeof topic !== 'string') {
    throw new Error('You must provide a valid topic to create a subscription.')
  }
  if (arguments.length === 3 && typeof callback === 'number') {
    priority = callback
    callback = context
    context = null
  }
  if (arguments.length === 2) {
    callback = context
    context = null
  }
  priority = priority || 10
  let topicIndex = 0
  let added
  const topics = topic.split(/\s/)
  const topicLength = topics.length
  for (; topicIndex < topicLength; topicIndex++) {
    topic = topics[topicIndex]
    added = false
    if (!subscriptions[topic]) {
      subscriptions[topic] = []
    }

    let i = subscriptions[topic].length - 1
    const subscriptionInfo = {
      callback: callback,
      context: context,
      priority: priority,
    }
    for (; i >= 0; i--) {
      // @ts-expect-error legacy dep
      if (subscriptions[topic][i].priority <= priority) {
        subscriptions[topic].splice(i + 1, 0, subscriptionInfo)
        added = true
        break
      }
    }
    if (!added) {
      subscriptions[topic].unshift(subscriptionInfo)
    }
  }
  return callback
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function unsubscribe(topic: string, context: any, callback?: any) {
  if (typeof topic !== 'string') {
    throw new Error('You must provide a valid topic to remove a subscription.')
  }
  if (arguments.length === 2) {
    callback = context
    context = null
  }
  if (!subscriptions[topic]) {
    return
  }
  let length = subscriptions[topic].length,
    i = 0
  for (; i < length; i++) {
    if (subscriptions[topic][i].callback === callback) {
      if (!context || subscriptions[topic][i].context === context) {
        subscriptions[topic].splice(i, 1)

        // Adjust counter and length for removed item
        i--
        length--
      }
    }
  }
}
